import BootstrapTable from 'react-bootstrap-table-next';
import { managerUserCheckboxFormatter } from '../helper';
import '../user-style.css';
import { usePostUpdateRole } from './hooks';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useToast } from '../../../../context';
import { LoadingSpinner } from '../../LoadingSpinner';
import { useDispatch } from 'react-redux';
import { useAllRoles } from '../../../../context/RoleContext';

const defaultColumns = [
  {
    dataField: 'role',
    text: 'Role',
    classes: 'col6',
    headerClasses: 'user-normal-header',
  },
];

function mapPermissionsFormData(tenancyRoles, permissionKeyValuePair) {
  if (tenancyRoles && permissionKeyValuePair) {
    return Object.keys(tenancyRoles).map((key) => {
      const containPermissions = tenancyRoles[key].value;
      const permissions = Object.keys(permissionKeyValuePair).reduce(
        (acc, key) => {
          acc[key] = containPermissions.includes(key);
          return acc;
        },
        {},
      );
      return {
        id: key,
        role: tenancyRoles[key].name,
        permissions,
      };
    });
  }
  return [];
}

export const ManagePermissions = ({ roleResults, isGetting }) => {
  const page = 1;
  const totalSize = 20;
  const dispatch = useDispatch();
  const sort = { dataField: 'id', order: 'asc' };
  const { postUpdateRole, isLoading: isUpdating } = usePostUpdateRole();
  const { fetchAllRoles } = useAllRoles();
  const isLoading = isGetting || isUpdating;
  const [isDirty, setIsDirty] = useState(false);
  const { setToast } = useToast();

  const { register, handleSubmit, watch, setValue, getValues, reset } = useForm(
    {
      defaultValues: {
        permissionsFormData: [],
      },
    },
  );

  const columns = roleResults?.permissionKeyValuePair
    ? Object.keys(roleResults?.permissionKeyValuePair).reduce(
        (acc, objectKey) => {
          return [
            ...acc,
            {
              dataField: `permissions.${objectKey}`,
              text: roleResults?.permissionKeyValuePair[objectKey],
              classes: 'col6',
              formatter: managerUserCheckboxFormatter,
              headerClasses: 'user-normal-header text-center',
              events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                  e.stopPropagation();
                  const currentValue = getValues('permissionsFormData');
                  const fieldToUpdate = column.dataField.split('.')[1];
                  const toUpdateValue =
                    !currentValue[rowIndex].permissions[fieldToUpdate];
                  currentValue[rowIndex].permissions[fieldToUpdate] =
                    toUpdateValue;
                  setValue('permissionsFormData', currentValue);
                  setIsDirty(true);
                },
              },
            },
          ];
        },
        defaultColumns,
      )
    : defaultColumns;

  const resetPermissionForm = async () => {
    reset({
      permissionsFormData: mapPermissionsFormData(
        roleResults?.tenancy_roles,
        roleResults?.permissionKeyValuePair,
      ),
    });
    setIsDirty(false);
  };

  const handleSubmitPermissionForm = async (values) => {
    const permissionsFormValue = values['permissionsFormData'];
    setToast('Updating roles...', { autoHide: false });
    const [result] = await postUpdateRole(permissionsFormValue);
    reset({
      permissionsFormData: mapPermissionsFormData(
        result.roles,
        roleResults?.permissionKeyValuePair,
      ),
    });
    fetchAllRoles();
    setIsDirty(false);
    setToast('Roles updated!');
  };

  useEffect(() => {
    if (roleResults) {
      const newData = mapPermissionsFormData(
        roleResults?.tenancy_roles,
        roleResults?.permissionKeyValuePair,
      );
      reset({
        permissionsFormData: newData,
      });
    }
  }, [roleResults]);

  const permissionsData = watch('permissionsFormData');

  return (
    <>
      {!isGetting ? (
        <form
          onSubmit={handleSubmit(handleSubmitPermissionForm)}
          className={isDirty ? 'offset-actions-bar' : ''}
        >
          <BootstrapTable
            bootstrap4
            keyField="id"
            wrapperClasses="table-responsive"
            id="manage-user-table"
            remote={{ pagination: true, filter: false, sort: true }}
            bordered={false}
            data={permissionsData}
            columns={columns}
            // rowEvents={rowEvents}
            // rowClasses={rowClasses}
            sort={sort}
            // onTableChange={handleTableChange}
          />
          {/* <PaginationFooter
        currentPage={page}
        totalPage={totalSize}
        pageSize={20}
      /> */}
          {isDirty ? (
            <div className="settings-page-actions settings-page-actions-right-0">
              <button
                type="button"
                className="cancel-change"
                onClick={resetPermissionForm}
                disabled={isLoading}
              >
                Cancel changes
              </button>
              <button
                type="submit"
                className="save-change"
                disabled={isLoading}
              >
                Save changes
              </button>
            </div>
          ) : null}
        </form>
      ) : (
        <LoadingSpinner showText="Loading roles..." />
      )}
    </>
  );
};
